import $ from "jquery";
import { Klass, csl } from "@pressmedia/webappbase";

export default {
	// fieldごとのエラーメッセージの表示
	showPrompt(objMsg) {
		const activeSheet = this.getActiveSheet();
		const reArr = /\[(\d+)\]$/;
		const reSub = /_(\w*)$/;
		const reCap = /--name$/;
		
		let $elm;
		
		Object.keys(objMsg).forEach(pk => {
			const arr = reArr.exec(pk);
			let k = !!arr ? pk.replace(reArr, "") : pk;
			
			const sub = reSub.exec(k);
			!!sub && ( k = k.replace(reSub, "") );
			
			const isCaption = reCap.test(k);
			isCaption && ( k = k.replace(reCap, "") );
		
			let vuw = activeSheet.find(k).get(0);
			
			// for vuwType: paramSet
			(vuw && vuw.vuwType === "paramSet") && ( vuw = vuw.get("field") );
			
			// for inpType: link, file, array
			(vuw && arr) && ( vuw = vuw.getChildren().get(parseInt(arr[1]) - 1) );
			
			// for inpType: array
			(vuw && sub) && ( vuw = vuw.get(sub[1]) );
			
			//for caption
			(vuw && isCaption) && ( vuw = vuw.get("caption") );
			
			if( vuw && vuw instanceof Klass("VuwField") ) {
				vuw.errorMessages.form = objMsg[pk];
				vuw.showPrompt("form");
				if($elm) {
					$elm.add(vuw.$self);
				} else {
					$elm = vuw.$self;
				}
				
			} else {
				csl.warn(`${this.klass}.showPrompt()`, `${pk} is not found in ${activeSheet.name}`);
				!!this.config.dataParams[pk] && this.alert(
					`<strong>${this.config.dataParams[pk].name}</strong><br>${objMsg[pk]}`
				);
			}
		});
		
		!!$elm && $(document.scrollingElement).animate({
			scrollTop: $elm.eq(0).offset().top - this.scrollBuffer
		}, 200);
	},
	
	scrollBuffer: 30
};
